import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const dateFormat = 'dd/MM/yyyy';

const popperModifiers = {
  flip: {
    behavior: ['bottom'],
  },
  preventOverflow: {
    enabled: false,
  },
  hide: {
    enabled: false,
  },
};

function DatePicker({ onChange, selected, ...rest }) {
  return (
    <ReactDatePicker
      onChange={onChange}
      selected={selected}
      dateFormat={dateFormat}
      placeholderText="DD/MM/YYYY"
      showMonthDropdown
      showYearDropdown
      popperPlacement="bottom"
      popperModifiers={popperModifiers}
      {...rest}
    />
  );
}

DatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.instanceOf(Date),
};

DatePicker.defaultProps = {
  selected: null,
};

export default DatePicker;
